module.exports = __webpack_public_path__ + "img/TKL-black.c4f5c8f4.png";